import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { SafeComponent } from '@fiverr-private/orca';
import { I18n } from '@fiverr-private/i18n-react';
import { Image } from '@fiverr-private/media';
import { getContext } from '@fiverr-private/fiverr_context';
import { SUPPORTED_FIVERR_LOCALES_KEYS } from '@fiverr-private/localization';
import { TRUSTED_BY_LOGOS, TRUSTED_BY_LOGOS_DE } from './constants';

const TrustBanner = () => {
    const { locale } = getContext();

    const logos = locale === SUPPORTED_FIVERR_LOCALES_KEYS.DE_DE ? TRUSTED_BY_LOGOS_DE : TRUSTED_BY_LOGOS;

    return (
        <Stack
            display="flex"
            direction="column"
            paddingY="10"
            paddingX="9"
            marginBottom="10"
            gap="2"
            backgroundColor="grey_100"
            maxWidth="100%"
        >
            <Container>
                <Typography style={{ fontWeight: 400 }} fontSize="b_xxl" margin="auto" textAlign="center">
                    <I18n k="logged_out_homepage.de.trusted_by.title" />
                </Typography>
            </Container>
            <Stack
                gap="7"
                justifyContent={{ default: 'flexStart', md: 'center' }}
                alignItems="center"
                maxWidth="100%"
                overflow="auto"
            >
                {logos.map(({ alt, src }) => (
                    <Image key={alt} alt={alt} width="178px" src={src} />
                ))}
            </Stack>
        </Stack>
    );
};

export default SafeComponent(TrustBanner);
